module.exports = __webpack_public_path__ + "img/map-mark.709dfb1e.svg";